



























import { Component, Vue } from 'vue-property-decorator';
import Campaigns from '@campaigns/shared/components/Campaigns.vue';
import { loadStoreOtherCampaignsAction } from '../../shared/actions';
import { AuthorizedUser, Campaign, CampaignTuple } from '@/app/shared/utilities/static-types';
import { getCurrentUser } from '@/app/shared/firebase/firebase-user';
import { isCampaignOwner } from '@/app/screens/App/screens/Campaigns/shared/utils';
import { getUserById } from '@adminRoles/shared/actions';
import TableActions from './components/TableActions.vue';
import ClickableCampaignItem from './components/ClickableCampaignItem.vue';

@Component({
  components: {
    Campaigns,
    TableActions,
    ClickableCampaignItem,
  },
})
export default class OtherCampaigns extends Vue {
  public currentUser: AuthorizedUser|undefined = undefined;
  public campaignsTuples: CampaignTuple[] = [];

  public async created() {
    this.currentUser = await this.loadCurrentUser();
    this.campaignsTuples = await loadStoreOtherCampaignsAction();
  }

  public async loadCurrentUser() {
    const { uid } = (await getCurrentUser())!;
    return  getUserById(uid);
  }

  public isCampaignOwner(campaign: Campaign) {
    return isCampaignOwner(campaign)(this.currentUser!);
  }
}
